import ApiService from "../../../../services/ApiService";
import translate from "../../../../services/Translate";

export const inviteUsersToEvaluation = (
  userIdsToInvite: number[],
  language: string,
  evaluationId: string,
  displayAlert: Function,
  dt_start?: string,
  successCallback?: Function
) => {
  ApiService.post(`evaluations/${evaluationId}/attempts`, {
    send_email: true,
    user_ids: userIdsToInvite,
    on_failed: false,
    dt_start: dt_start ? new Date(dt_start).toISOString() : undefined,
  })
    .then((response) => {
      displayAlert({
        type: "success",
        title: translate(language, "PAGES.EVALUATION.MODAL.INVITATION.ALERTS.SUCCESS"),
        extraContent: response.data?.message,
        clickOutsideToClose: true,
      });
      successCallback?.();
    })
    .catch((error) => {
      console.error("Error inviting users to evaluation", error);
      displayAlert({
        type: "danger",
        title: translate(language, "PAGES.EVALUATION.MODAL.INVITATION.ALERTS.FAILED"),
        clickOutsideToClose: true,
      });
    });
};
